export const getApiUrl = () => {
  const envUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  if (envUrl) return envUrl;

  if (typeof window !== 'undefined') {
    const { hostname } = window.location;

    // Local dev: fall back to local API server
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return (process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5005').replace(/\/$/, '');
    }
  }

  // Production builds must set REACT_APP_API_URL (baked in at build time).
  // Prefer failing closed over calling the static site host and getting 404s.
  return 'https://clearance-scouts-server.onrender.com';
};


